import { gql } from '@apollo/client';
import React from 'react';
import Avatar from '../../components/Avatar';
import type { UserProfileAvatarEditor_UserFragment } from '../../graphql/generated/graphqlTypes';
import SettingsImageEditor from '../../settings/SettingsImageEditor';
import useUpdateUserProfile from './useUpdateUserProfile';

const USER_FRAGMENT = gql`
  fragment UserProfileAvatarEditor_user on User {
    id
    ...Avatar_user
  }
  ${Avatar.fragments.user}
`;

interface UserProfileAvatarEditorProps {
  onUpload?: () => void;
  user: UserProfileAvatarEditor_UserFragment;
  size?: React.ComponentProps<typeof Avatar>['size'];
}

const UserProfileAvatarEditor = ({
  onUpload,
  user,
  size = 'large',
}: UserProfileAvatarEditorProps) => {
  const updateUserProfile = useUpdateUserProfile({
    user,
  });

  const handleUpload = (avatar: File) =>
    updateUserProfile({ avatar }).then(onUpload);

  return (
    <SettingsImageEditor onUpload={handleUpload}>
      <Avatar size={size} user={user} />
    </SettingsImageEditor>
  );
};

UserProfileAvatarEditor.fragments = {
  user: USER_FRAGMENT,
};

export default UserProfileAvatarEditor;
